import React from 'react';
import { cn } from '@/lib';

interface MessageContentWrapperProps {
    children: React.ReactNode;
    className?: string;
}

export const MessageContentWrapper: React.FC<MessageContentWrapperProps> = ({ children, className = '' }) => {
    return <div className={cn('mt-2 ml-8 max-w-3/4', className)}>{children}</div>;
};
